<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 60 60"
    role="presentation"
    :fill="iconColor"
    data-cy="svg--has-parking">
    <defs>
      <path id="aparking" d="M29.5 9.328c-7.826 0-14.192 6.387-14.192 14.238S21.674 37.805 29.5 37.805c7.826 0 14.192-6.388 14.192-14.239 0-7.85-6.366-14.238-14.192-14.238zm0 25.313c-6.087 0-11.038-4.968-11.038-11.075 0-6.106 4.951-11.074 11.038-11.074 6.087 0 11.038 4.968 11.038 11.074 0 6.107-4.951 11.075-11.038 11.075zM29.5 3C40.804 3 50 12.226 50 23.566c0 4.476-1.414 8.733-4.088 12.313L30.766 56.361a1.575 1.575 0 0 1-2.532 0l-15.15-20.488A20.416 20.416 0 0 1 9 23.566C9 12.226 18.196 3 29.5 3zm13.883 30.988a17.28 17.28 0 0 0 3.463-10.422c0-9.595-7.781-17.402-17.346-17.402-9.565 0-17.346 7.807-17.346 17.402 0 3.786 1.196 7.387 3.458 10.416L29.5 52.762l13.883-18.774zM31.077 15.656h-4.73a1.58 1.58 0 0 0-1.578 1.582v12.657a1.58 1.58 0 0 0 1.577 1.582 1.58 1.58 0 0 0 1.577-1.582v-4.747h3.154c2.608 0 4.73-2.129 4.73-4.746 0-2.617-2.122-4.746-4.73-4.746zm0 6.328h-3.154V18.82h3.154a1.581 1.581 0 0 1 0 3.164z"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="bparking" fill="#fff">
          <use xlink:href="#aparking"/>
        </mask>
        <use :fill="iconColor" fill-rule="nonzero" xlink:href="#aparking"/>
        <g :fill="iconColor" mask="url(#bparking)">
          <path d="M0 0h60v60H0z"/>
        </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32
    },
    height: {
      type: [Number, String],
      default: 32
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
